import { useTranslation } from 'react-i18next'
import { GoalCycleFields } from './GoalCycleFields'
import type { GoalCycleDraft } from './goalsUtils'

/** The "Next" step of a one-cycle Metas & OKRs space (F-50 criterion 1): the cycle is created right after the space, and the person lands in it. */
export const GoalCycleSingleStep = ({ draft, onChange, errors, disabled = false }: {
  draft: GoalCycleDraft
  onChange: (d: GoalCycleDraft) => void
  errors?: Partial<Record<keyof GoalCycleDraft, string>> | null
  disabled?: boolean
}) => {
  const { t } = useTranslation('goals')
  return (
    <div className="min-w-0 space-y-5" data-testid="goal-cycle-single-step">
      <div className="space-y-1">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-900">{t('wizard.step')}</h3>
        <p className="text-xs text-gray-500">{t('wizard.stepHint')}</p>
      </div>
      <GoalCycleFields draft={draft} onChange={onChange} errors={errors} disabled={disabled} idPrefix="wizard-goal-cycle" />
      <p className="text-xs text-gray-500">{t('wizard.bornOpen')}</p>
    </div>
  )
}
